import { Loading } from '@pandiafi/components'
import React, { Suspense } from 'react'

import { DefectNoticeList } from 'components/DefectNoticeList'
import { SidebarDataLoader } from 'views/DefectNotice/DefectNoticeSidebarDataLoader'

export default function DefectNotices() {
  return (
    <Suspense fallback={<Loading variant="details" />}>
      <SidebarDataLoader>
        {({ defectNotices }) =>
          defectNotices.length > 0 ? (
            <div className="phone:px-4">
              <DefectNoticeList defectNotices={defectNotices} />
            </div>
          ) : null
        }
      </SidebarDataLoader>
    </Suspense>
  )
}
